import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import {
  ContainerLayout,
  Intro,
  Title,
  SubTitle,
  Text,
} from "../components/common"
import { MediaLink } from "../components/layout/footer/style"

const Experience = () => {
  return (
    <>
      <Layout>
        <SEO title="Experience" />
        <Intro>
          <ContainerLayout>
            <Title className="big-title">Experience</Title>
            <hr />
            <div className="flex">
              <SubTitle>Associate Software Developer</SubTitle>
              <Title className="line-height-reset">
                <MediaLink
                  className="lined-link bigger"
                  href={"https://myparadigm.com/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={"visit website"}
                >
                  Paradigm
                </MediaLink>
              </Title>
            </div>
            <Text className="reset-margin">
              Develop Front-End UI/UX features for Enterprise SaaS Window and Door Configurator application for a wide range of customers with React, Redux, SASS, Bootstrap, Laravel, Docker and Git.
              Write comprehensive automated E2E & API tests with Playwright using Typescript and Postman.
              Participate in daily standups and peer code review sessions with senior programmers.
              Track tickets with Jira, coordinate development with PMs, Consultants and other Developers.
              Build and deploy Docker containers to AWS & Microsoft Azure with Jenkins.
            </Text>
            <div className="flex">
              <SubTitle>Freelance Web Developer</SubTitle>
              <Title className="line-height-reset">
                <MediaLink
                  className="lined-link bigger"
                  href={"https://pagepaladin.com/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={"visit website"}
                >
                  Page Paladin
                </MediaLink>
              </Title>
            </div>
            <Text className="reset-margin">
              Collaborate with customers to design & develop flexible web development solutions
              Worked with Google API and CMS to create easy-to-maintain, low-complexity experience for client
            </Text>
            <div className="flex">
              <SubTitle>Junior Frontend Developer</SubTitle>
              <Title className="line-height-reset">
                <MediaLink
                  className="lined-link bigger"
                  href={"https://www.bluejestic.com/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={"visit website"}
                >
                  Bluejestic
                </MediaLink>
              </Title>
            </div>
            <Text className="reset-margin">
              Create scalable Front-End components & pages using React, Next,
              Redux, Sass, GraphQL, etc. Attend weekly stand up meetings.
              Coordinate implementations with CEO & developers on the enterprise
              ecommerce application.
            </Text>
            <div className="flex">
              <SubTitle>Full Stack Teaching Assistant</SubTitle>
              <Title className="line-height-reset">
                <MediaLink
                  className="lined-link bigger"
                  href={"https://www.trilogyed.com/"}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={"visit website"}
                >
                  2U
                </MediaLink>
              </Title>
            </div>
            <Text className="reset-margin">
              Assist students & instructor with coding curriculum & lessons
              inside and outside of class. Host a weekly office hours sessions
              with students.
            </Text>
          </ContainerLayout>
        </Intro>
      </Layout>
    </>
  )
}

export default Experience
